/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Structured cause of a jurisdiction refusal. ANONYMISED_CONNECTION is a VPN/Tor/hosting IP and is unrelated to the resolved country, so copy branching on it must not name a place.
 * @export
 */
export const JurisdictionBlockReason = {
    COUNTRY: 'COUNTRY',
    COUNTRY_NOT_ALLOWED: 'COUNTRY_NOT_ALLOWED',
    REGION: 'REGION',
    PRIZE_VALUE_EXCEEDS_REGION_LIMIT: 'PRIZE_VALUE_EXCEEDS_REGION_LIMIT',
    ANONYMISED_CONNECTION: 'ANONYMISED_CONNECTION',
    UNKNOWN_LOCATION: 'UNKNOWN_LOCATION'
} as const;
export type JurisdictionBlockReason = typeof JurisdictionBlockReason[keyof typeof JurisdictionBlockReason];


export function instanceOfJurisdictionBlockReason(value: any): boolean {
    for (const key in JurisdictionBlockReason) {
        if (Object.prototype.hasOwnProperty.call(JurisdictionBlockReason, key)) {
            if (JurisdictionBlockReason[key as keyof typeof JurisdictionBlockReason] === value) {
                return true;
            }
        }
    }
    return false;
}

export function JurisdictionBlockReasonFromJSON(json: any): JurisdictionBlockReason {
    return JurisdictionBlockReasonFromJSONTyped(json, false);
}

export function JurisdictionBlockReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): JurisdictionBlockReason {
    return json as JurisdictionBlockReason;
}

export function JurisdictionBlockReasonToJSON(value?: JurisdictionBlockReason | null): any {
    return value as any;
}

export function JurisdictionBlockReasonToJSONTyped(value: any, ignoreDiscriminator: boolean): JurisdictionBlockReason {
    return value as JurisdictionBlockReason;
}

